// استيراد دوال React لإدارة الحالات والتأثيرات الجانبية
import { useEffect, useState } from "react";
// استيراد روابط API الخاصة بالمستخدم والمستخدمين
import { USER, USERS } from "../../API/Api";
// استيراد كائن Axios المهيأ
import { Axios } from "../../API/Axios";
// استيراد Link من React Router للتنقل بين الصفحات
import { Link } from "react-router-dom";
// استيراد أيقونة الإضافة من Font Awesome
import { faPlus } from "@fortawesome/free-solid-svg-icons";
// استيراد مكون FontAwesomeIcon لعرض الأيقونات
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// استيراد هوك المستخدم الحالي من السياق
import { useCurrentUser } from "../../Context/CurrentUserContext";
// استيراد هوك اللغة
import { useLanguage } from "../../Context/LanguageContext";
// استيراد مكون عرض الجدول
import TableShow from "./Table";
// استيراد ملف الأنماط
import "./Users.css";

// المكون الرئيسي لإدارة المستخدمين
export default function Users ()
{
    // استيراد دالة الترجمة من سياق اللغة
    const { t } = useLanguage();
    // الحصول على بيانات المستخدم الحالي من السياق (متوفرة من الحارس)
    const { user: currentUser } = useCurrentUser();

    // حالة لتخزين قائمة المستخدمين
    const [ users, setUsers ] = useState( [] );
    // حالة لتحديث الجدول عند الحذف
    const [ deleteTick, setDeleteTick ] = useState( false );
    // حالة لتحديد عدد العناصر في الصفحة الواحدة
    const [ limit, setLimit ] = useState( 5 );
    // حالة لتحديد رقم الصفحة الحالية
    const [ page, setPage ] = useState( 1 );
    // حالة التحميل
    const [ loading, setLoading ] = useState( false );
    // حالة لتخزين العدد الإجمالي للمستخدمين
    const [ total, setTotal ] = useState( 0 );

    // تأثير جانبي لجلب بيانات المستخدمين عند تغيير الصفحة أو الحد أو الحذف
    useEffect( () =>
    {
        // تفعيل حالة التحميل
        setLoading( true );
        // إرسال طلب GET لجلب المستخدمين مع معلمات الترقيم
        Axios.get( `/${ USERS }?limit=${ limit }&page=${ page }` )
            .then( ( res ) =>
            {
                // تخزين بيانات المستخدمين
                setUsers( res.data.data );
                // تخزين العدد الإجمالي
                setTotal( res.data.total );
            } )
            .catch( ( error ) => console.log( "Error fetching users:", error ) ) // معالجة الأخطاء
            .finally( () => setLoading( false ) ); // إلغاء حالة التحميل في النهاية
    }, [ deleteTick, limit, page ] ); // إعادة التشغيل عند تغيير هذه التبعيات

    // تعريف أعمدة الجدول مع الترجمة
    const header = [
        { key: "name", name: t( 'usersPage.columnName' ) }, // عمود الاسم
        { key: "email", name: t( 'usersPage.columnEmail' ) }, // عمود البريد الإلكتروني
        { key: "role", name: t( 'usersPage.columnRole' ) }, // عمود الدور
        { key: "created_at", name: t( 'usersPage.columnCreated' ) }, // عمود تاريخ الإنشاء
        { key: "updated_at", name: t( 'usersPage.columnLastLogin' ) }, // عمود آخر تسجيل دخول
    ];

    // دالة غير متزامنة لحذف مستخدم
    async function handleDelete ( id )
    {
        try
        {
            // إرسال طلب DELETE لحذف المستخدم
            await Axios.delete( `/${ USER }/${ id }` );
            // تحديث قائمة المستخدمين بحذف المستخدم المحدد
            setUsers( ( prev ) => prev.filter( ( item ) => item.id !== id ) );
        } catch ( error )
        {
            // طباعة خطأ الحذف في وحدة التحكم
            console.log( "Error deleting user:", error );
        }
    }

    // عرض واجهة إدارة المستخدمين
    return (
        <div className="container py-4"> {/* حاوية رئيسية مع مسافات */ }
            <div className="users-page-card"> {/* بطاقة صفحة المستخدمين */ }
                <div className="users-page-header"> {/* رأس الصفحة */ }
                    <div> {/* قسم العنوان */ }
                        <span className="users-page-eyebrow">{ t( 'usersPage.eyebrow' ) }</span> {/* النص العلوي */ }
                        <h2>{ t( 'usersPage.title' ) }</h2> {/* العنوان الرئيسي */ }
                    </div>
                    {/* زر إضافة مستخدم جديد */ }
                    <Link className="users-page-add-btn" to="/dashboard/users/add">
                        <FontAwesomeIcon icon={ faPlus } /> {/* أيقونة الإضافة */ }
                        <span>{ t( 'usersPage.addButton' ) }</span> {/* نص الزر */ }
                    </Link>
                </div>

                {/* مكون عرض الجدول مع تمرير الخصائص */ }
                <TableShow
                    header={ header } // أعمدة الجدول
                    data={ users } // بيانات المستخدمين
                    currentUser={ currentUser } // المستخدم الحالي (لصلاحيات الحذف)
                    delete={ handleDelete } // دالة الحذف
                    limit={ limit } // عدد العناصر في الصفحة
                    page={ page } // الصفحة الحالية
                    setpage={ setPage } // دالة تغيير الصفحة
                    setLimit={ setLimit } // دالة تغيير الحد
                    loading={ loading } // حالة التحميل
                    total={ total } // العدد الإجمالي
                    search="name" // حقل البحث
                    searchLinck="user" // رابط البحث
                />
            </div>
        </div>
    );
}